import React from 'react';
import Viewer from './pages/ViewerPage/index.js';
import './App.css';
import { BrowserRouter, Route } from 'react-router-dom';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <Route exact path='/viewer/:id' component={Viewer} />
      </BrowserRouter>
    </div>
  );
}

export default App;
